import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class BroadcastService 
{  
  private messageSource = new BehaviorSubject(''); 
   
  private editedresponse;

  constructor() { }  

  currentobject = this.messageSource.asObservable()

  getobject()
  {
    this.currentobject.subscribe(response=>
    {
      this.editedresponse=response;
    })
    
    return this.editedresponse
  }
  

  setobject(data: any) 
  {    
    this.messageSource.next(data);
  }

  clearobject()
  {
    this.messageSource.next(undefined);
  }

  
  
}


// WEBPACK FOOTER //
// ./src/app/service/datatransfer.service.ts